import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/ui/core/dialog'
import { VStack } from '@/ui/core/stack'
import { useState } from 'react'
import Toast from 'react-native-toast-message'
import { BillingCardForm } from '../BillingCardForm'

const UpdateCardModal = () => {
	const [open, setOpen] = useState(false)

	const onComplete = () => {
		analytics.trackEvent('updated-billing-info')

		setOpen(false)
		Toast.show({
			type: 'success',
			text1: 'Successfully updated card',
		})
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost">
					<ButtonText>Update</ButtonText>
				</Button>
			</DialogTrigger>
			<DialogContent
				variant="billing"
				showLogo={false}
				className="flex lg:items-center items-start"
			>
				<VStack gap={60} className="lg:w-80 native:w-screen native:px-12">
					<DialogHeader>
						<DialogTitle className="text-5xl font-primary-demi uppercase text-palette_6 pt-3">
							Your new card.
						</DialogTitle>
					</DialogHeader>
					<BillingCardForm onComplete={onComplete} />
				</VStack>
			</DialogContent>
		</Dialog>
	)
}

export { UpdateCardModal }
